export const classOverviewTeacher = [
  {
    header: "Getting started",
    body: "You can exit the tour and restart it anytime from this Help and Resources button. Use the button to see what resources are available to you.",
    position: "rightbottom",
    mountPosition: "left",
    targetId: "help-and-resources",
  },
  {
    header: "Your dashboard",
    body: "Access your classes, skill review recommendations and your account settings within the Home page.",
    position: "topcenter",
    mountPosition: "bottom",
    targetId: "nav-home-button",
  },
  {
    header: "Class navigation",
    body: "Quickly access classes you're teaching from the Your Classes tab.",
    position: "topcenter",
    mountPosition: "bottom",
    targetId: "nav-your-classes-button",
  },
  {
    header: "Course Content",
    body: "Browse all of the lesson videos and activities available to students in the Explore page.",
    position: "topcenter",
    mountPosition: "bottom",
    targetId: "nav-explore-button",
  },
  {
    header: "Your Classes",
    body: "Insights, student info, and class settings are now available from within each class page.",
    position: "bottomcenter",
    mountPosition: "top",
    targetId: "classes-class-container",
  },
  {
    header: "Learning targets with top errors",
    body: "Identify what activities students are using the most hints for and having the most errors in.",
    position: "bottomcenter",
    mountPosition: "top",
    targetId: "lesson-plans-card",
  },
  {
    header: "That's the end of this tour!",
    body: "If you need any help or support, send an email to digitsupport@asu.edu and we will get back to you in 24 hours.",
    position: "center",
    mountPosition: "centerscreen",
    targetId: "main",
    bgColor: "#6E846F",
  },
];

export const classOverviewAdminSuper = [
  {
    header: "Getting started",
    body: "You can exit the tour and restart it anytime from this Help and Resources button. Use the button to see what resources are available to you.",
    position: "rightbottom",
    mountPosition: "left",
    targetId: "help-and-resources",
  },
  {
    header: "Your dashboard",
    body: "Access class insights and your account settings within the Home page.",
    position: "topcenter",
    mountPosition: "bottom",
    targetId: "nav-home-button",
  },
  {
    header: "Management",
    body: "View, edit, and add classes and students from the Management page.",
    position: "topcenter",
    mountPosition: "bottom",
    targetId: "nav-management-button",
  },
  {
    header: "Class pages",
    body: "Insights are now available within each class page along with the options to view student information and edit class settings.",
    position: "bottomcenter",
    mountPosition: "top",
    targetId: "classes-class-container",
  },
  {
    header: "That's the end of this tour!",
    body: "If you need any help or support, send an email to digitsupport@asu.edu and we will get back to you in 24 hours.",
    position: "center",
    mountPosition: "centerscreen",
    targetId: "main",
    bgColor: "#6E846F",
  },
];
